import { baseApi, QueryPayload } from 'src/api'

export type ArchiveEntry = {
    filename: string;
    size: number;
    mimeType: string | null;
}

export const apiModule = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getMaterialHomeworkFiles: builder.query<
            ArchiveEntry[],
            { params: { subjectId: number, materialId: number } }
        >({
            providesTags: (_res, _err, { params }) => [
                { type: 'Materials', id: params.materialId },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/subjects/${params.subjectId}/materials/${params.materialId}/homework/files`,
                method: 'GET',
            }),
        }),
        
        getMaterialLessonFiles: builder.query<
            ArchiveEntry[],
            { params: { subjectId: number, materialId: number } }
        >({
            providesTags: (_res, _err, { params }) => [
                { type: 'Materials', id: params.materialId },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/subjects/${params.subjectId}/materials/${params.materialId}/lesson/files`,
                method: 'GET',
            }),
        }),
        
        getMaterialPracticeFiles: builder.query<
            ArchiveEntry[],
            { params: { subjectId: number, materialId: number } }
        >({
            providesTags: (_res, _err, { params }) => [
                { type: 'Materials', id: params.materialId },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/subjects/${params.subjectId}/materials/${params.materialId}/practice/files`,
                method: 'GET',
            }),
        }),
        
        getMaterialPresentationFiles: builder.query<
            ArchiveEntry[],
            { params: { subjectId: number, materialId: number } }
        >({
            providesTags: (_res, _err, { params }) => [
                { type: 'Materials', id: params.materialId },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/subjects/${params.subjectId}/materials/${params.materialId}/presentation/files`,
                method: 'GET',
            }),
        }),
    }),
})

export const {
    useGetMaterialLessonFilesQuery,
    useGetMaterialHomeworkFilesQuery,
    useGetMaterialPracticeFilesQuery,
    useGetMaterialPresentationFilesQuery,
} = apiModule